module.exports = __webpack_public_path__ + "static/media/S1N9-3.ab1bb580.svg";